import React, { useEffect, useState } from "react";
import "./OverviewInt.css";
import InternalBar from "../TopLayout/InternalBar/InternalBar";
import BottomCardGroupInt from "../../BottomCardGroupInt/BottomCardGroupInt";
import { useHistory } from "react-router-dom";
import {cosmosTrackService} from "../../../../cosmosTracking/cosmosTrackService";
import {sale_video_tutor} from "../../../../cosmosTracking/cosmosEvents";
import MessageStudents from "../MessageStudents/MessageStudents";
import { makeApiCal, POST } from "../../util";
import baseURLGlobal from "../../../../utils/util";
import TaskCardMini from "./task-card-mini/taskCardMini";
import birthdayVideo from '../../../../assets/videos/cp-holi-tutor-video.mp4'
import headerTitle from '../../../../assets/images/happy-holi-overview-tittle-2026.png';

function OverViewInt(props) { 
  const { data, swipeActions, scrollNav } = props;
  const history = useHistory();
  const bottomCard = data?.bottomCard;
  const campaignOrg = data?.campaignOrg;
  const [tutorMsg, setTutorMsg] = useState("");

  const handleSubmitMsg = (message, callback) => {
    const action = {
      method: POST,
      route: 'v1/campaign/tutor/message',
      body: {
        message: message,
        campaignId: campaignOrg?.campaignId
      },
      storeData: (e) => console.log(e),
      catchError: (e) => console.error(e),
    };
    makeApiCal(
      action,
      (data) => {
        callback && callback()
      },
      (error) => {
        console.error('Failure callback:', error);
      }
    );
  }

  const baseUrl = baseURLGlobal;
  const token = new URLSearchParams(window.location.search).get("token");

  const handleEditMsg = () => {
    let myHeaders = new Headers();
		myHeaders.append('api-version', '25');
		myHeaders.append('x-access-token', token);
		let requestOptions = {
			method: 'GET',
			headers: myHeaders
		};
		fetch(`${baseUrl}/v1/campaign/detailPage`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				setTutorMsg(result?.data?.campaignOrg?.message);
			})
			.catch((error) => console.log('error', error)
    );
  }
  return (
    <>
      <div className="page-content page-content-overview" {...swipeActions}>
        <div className="overview-header">
          <img className="header-top-title" src={headerTitle} alt="img"/>
          <h3 className="header-top-subtittle">Complete tasks & win <span className="amazin-gift">Amazing Gifts!</span></h3>
          <div className="overview-video">
            <video
                poster="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/video-thumbnail-dark.png"
                src={birthdayVideo}
                controls
                controlsList="nofullscreen nodownload noplaybackrate"
                disablePictureInPicture
                playsInline
                onPlay={() => cosmosTrackService(sale_video_tutor)}>
            </video>
            <div>
              <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/diwali-overview-graph.png" alt="img" width={18} height={18}/>
              <h4><span>About</span> 80% Teachers won Gifts in this sale</h4>
            </div>
          </div>
        </div>
        {data?.campaignOrg?.isPremiumTutor === 1 &&
            <MessageStudents onSubmitMessage={handleSubmitMsg} onEditMsg={handleEditMsg} tutorMsg={tutorMsg}/>
        }
        <TaskCardMini cards={data?.statCard} scrollNav={scrollNav}></TaskCardMini>
        {/* <div className="overview-bottom-card">
          <h2>3x Growth</h2>
          <p>3x your earnings by our Specialised features & get chance to win amazing gifts.</p>
          <BottomCardGroupInt bottomCard={bottomCard} campaignOrg={campaignOrg}></BottomCardGroupInt>
        </div> */}
      </div>
    </>
  );
}

export default OverViewInt;
